// Counter sales — ADMIN (operations) workspace page.
// Personal sales (made by the admin) + walk-in entries, in one place.

import React from 'react';
import OpsLayout from '../../components/layout/OpsLayout.jsx';
import CounterSales from '../../components/ops/CounterSales.jsx';
import { opsCounterApi } from '../../api/opsApi';

const OpsCounterPage = () => (
  <OpsLayout>
    <CounterSales api={opsCounterApi} />
  </OpsLayout>
);

export default OpsCounterPage;
